import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const stats = [
  { number: '16+', label: 'Years Experience' },
  { number: '5000+', label: 'Successful Moves' },
  { number: '100%', label: 'Customer Satisfaction' },
];

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-b from-[#0d1f35] via-[#1a2f4a] to-[#1e3a5f]">
      <div className="absolute inset-0 opacity-5" style={{
        backgroundImage: 'linear-gradient(#ffffff 1px, transparent 1px), linear-gradient(90deg, #ffffff 1px, transparent 1px)',
        backgroundSize: '60px 60px'
      }} />
      <div className="absolute inset-0 bg-gradient-to-b from-black/10 via-transparent to-[#1e3a5f]/80" />

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9 }}
          className="flex flex-col items-center"
        >
          <div className="flex justify-center mb-12">
            <img
              src="https://static.readdy.ai/image/d40f812adce9746c671cc6e9152e021e/0ce60cc9cd67bd7abb608b30f1f31592.jpeg"
              alt="LONE Transportation & Relocation Services Logo"
              style={{
                height: '650px',
                maxWidth: '95vw',
                objectFit: 'contain',
                mixBlendMode: 'lighten',
                filter: 'drop-shadow(0 0 40px rgba(255,255,255,0.08))',
              }}
            />
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-4">
            <Link
              to="/operations"
              className="px-10 py-4 bg-white text-[#1e3a5f] font-orbitron font-bold text-sm rounded-md hover:bg-gray-100 transition-all duration-300 whitespace-nowrap cursor-pointer tracking-wider"
            >
              VIEW OUR SERVICES
            </Link>
            <a
              href="tel:+14158885336"
              className="px-10 py-4 bg-transparent border-2 border-white/70 text-white font-orbitron font-semibold text-sm rounded-md hover:bg-white hover:text-[#1e3a5f] transition-all duration-300 whitespace-nowrap cursor-pointer tracking-wider"
            >
              GET A QUOTE
            </a>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-6"
        >
          {stats.map((s, i) => (
            <div key={i} className="bg-white/8 backdrop-blur-md border border-white/15 rounded-xl p-8 hover:bg-white/12 hover:border-white/30 transition-all duration-300">
              <div className="font-orbitron text-5xl font-bold text-white mb-2">{s.number}</div>
              <div className="font-inter text-white/70 text-sm tracking-wider">{s.label}</div>
            </div>
          ))}
        </motion.div>
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 1.2 }}
        className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center space-y-2"
      >
        <span className="font-inter text-white/40 text-xs tracking-widest">SCROLL DOWN</span>
        <div className="w-6 h-10 border-2 border-white/20 rounded-full flex items-start justify-center p-2">
          <motion.div animate={{ y: [0, 12, 0] }} transition={{ duration: 1.5, repeat: Infinity }} className="w-1.5 h-1.5 bg-white/60 rounded-full" />
        </div>
      </motion.div>
    </section>
  );
}
